<template>
  <div v-if="showTestButton" class="pf-test-button">
    <button 
      @click="openProtectedArticle" 
      class="pf-test-btn" 
      :disabled="!isInitialized"
      :title="isInitialized ? 'Test ProductFruits Protected Article' : 'Waiting for ProductFruits to initialize...'"
    >
      🔒 Test Protected Article
      <span v-if="!isInitialized" class="pf-loading">⏳</span>
    </button>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue';

const isInitialized = ref(false);

// Only show in local, dev, and test environments
const showTestButton = computed(() => {
  const env = import.meta.env.MODE;
  return ['development', 'mock', 'test'].includes(env) || 
         window.location.hostname === 'localhost' || 
         window.location.hostname === '127.0.0.1' ||
         window.location.hostname.includes('local.') ||
         window.location.hostname.includes('dev.') ||
         window.location.hostname.includes('test.');
});

const checkInitialization = () => {
  const cached = sessionStorage.getItem('pf_hmac_cache');
  isInitialized.value = !!cached;
};

const openProtectedArticle = () => {
  const cached = sessionStorage.getItem('pf_hmac_cache');
  if (!cached) {
    console.warn('ProductFruits not initialized - no HMAC available');
    return;
  }

  try {
    const data = JSON.parse(cached);
    const hmacAuthParam = {
      username: data.username,
      hmac: {
        hash: data.hmac
      }
    };
    
    const baseUrl = 'https://x2muwzluuscjvkw.productfruits.help/en/article/lorem-ipsum-protected';
    const protectedArticleUrl = baseUrl + '?hmac=' + encodeURIComponent(JSON.stringify(hmacAuthParam));
    
    window.open(protectedArticleUrl, '_blank');
    console.log('✓ Opened protected article with HMAC authentication');
  } catch (error) {
    console.error('✗ Failed to open protected article:', error);
  }
};

onMounted(() => {
  checkInitialization();
  
  // Check periodically if ProductFruits gets initialized
  const interval = setInterval(() => {
    checkInitialization();
  }, 2000);
  
  // Cleanup on unmount
  return () => clearInterval(interval);
});
</script>

<style scoped>
.pf-test-button {
  position: fixed;
  bottom: 80px;
  left: 20px;
  z-index: 9999;
}

.pf-test-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 12px;
  padding: 14px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.pf-test-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.6);
}

.pf-test-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 10px rgba(102, 126, 234, 0.4);
}

.pf-test-btn:disabled {
  background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);
  cursor: not-allowed;
  opacity: 0.6;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.pf-test-btn:disabled:hover {
  transform: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.pf-loading {
  display: inline-block;
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
</style>
